/**
 * Get color and background color for similarity percentage
 * @param {number} similarity - Similarity percentage (0-100)
 * @returns {Object} Object with color and background CSS variable strings
 */
export function getSimilarityColors(similarity) {
  const colorMap = {
    danger: {
      color: "var(--color-text-semantic-onerror, #dc3545)",
      background: "var(--color-surface-semantic-error-light, #FFEAEC)",
    },
    warning: {
      color: "var(--color-text-semantic-onwarning, #d76812)",
      background: "var(--color-surface-semantic-warning-light, #FFF4E6)",
    },
    neutral: {
      color: "var(--color-text-neutral-secondary, #566370)",
      background: "var(--color-surface-neutral-subtle, #F5F7F9)",
    },
  };

  if (similarity < 30) {
    return colorMap.neutral;
  } else if (similarity <= 70) {
    return colorMap.warning;
  }

  return colorMap.danger;
}
